import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useTenant } from '@/contexts/TenantContext';
import SetupWizard from './SetupWizard';

// ---------------------------------------------------------------------------
// SetupFab — floating "+" button, bottom-right, that opens the SetupWizard.
//
// Visible to owners/admins only ('operator' maps to owner, same as the nav —
// see Sidebar.tsx) and never in simple mode, where subscribers get an
// agent-driven nav and shouldn't be re-running setup.
//
// On mobile the button sits above the fixed MobileNav tab bar (main's
// pb-24 md:pb-0 reserves the same space); z-30 keeps it above page content
// but UNDER MobileNav's expanded 'More' sheet + backdrop (both z-40) and the
// Modal overlay (z-50). The wizard is mounted only while open so every open
// starts with fresh state.
// ---------------------------------------------------------------------------

function SetupFab() {
  const { user } = useAuth();
  const { isSimpleMode } = useTenant();
  const [open, setOpen] = useState(false);

  const role = user?.role === 'operator' ? 'owner' : user?.role;
  if ((role !== 'owner' && role !== 'admin') || isSimpleMode) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        aria-label="Open setup wizard"
        title="Set up your workspace"
        className="fixed z-30 right-4 bottom-24 md:right-6 md:bottom-6 w-12 h-12 rounded-full gradient-blue text-white shadow-lg shadow-accent/30 flex items-center justify-center hover:opacity-90 transition-all duration-200 cursor-pointer"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        >
          <path d="M12 5v14M5 12h14" />
        </svg>
      </button>
      {open && <SetupWizard open onClose={() => setOpen(false)} />}
    </>
  );
}

export default SetupFab;
